<div class="flex flex-col gap-1">
  @if (graphView() === 'line') {
    @switch (granularity()) {
      @case ('YEAR') {
        <div>{{ timestamp() | date: 'cccc dd.MM.yyyy' }}</div>
      }
      @case ('MONTH') {
        <div>{{ timestamp() | date: 'cccc dd.MM.yyyy' }}</div>
      }
      @case ('WEEK') {
        <div>{{ timestamp() | date: 'cccc dd.MM.yyyy' }}</div>
      }
      @case ('DAY') {
        <div>{{ timestamp() | date: 'dd.MM.yyyy HH:mm' }}</div>
      }
    }
  } @else {
    @switch (granularity()) {
      @case ('YEAR') {
        <div>{{ timestamp() | date: 'MMMM yyyy' }}</div>
      }
      @case ('MONTH') {
        <div>{{ timestamp() | date: 'cccc dd.MM.yyyy' }}</div>
      }
      @case ('WEEK') {
        <div>{{ timestamp() | date: 'cccc dd.MM.yyyy' }}</div>
      }
      @case ('DAY') {
        <div>{{ timestamp() | date: 'dd.MM.yyyy HH:mm' }}</div>
      }
    }
  }
  @let consumption = value();
  @if (consumption !== undefined) {
    <div>
      {{ 'cockpit.analysis.consumption.graph.tooltipConsumptionLabel' | transloco }}
      <span class="font-semibold"> {{ consumption | germanNumber }} kWh </span>
    </div>
  }
</div>
